module.exports = __webpack_public_path__ + "static/media/BAFewSelected.f27d9cc2.svg";